export class Purchase {
  constructor(
    public id: number = null,
    public vendor_id: number = null, // ligado a USERS

    public hideline: number = 0,
    public po: string = "",

    public processing_id: number = null,
    public pickup_id: number = null,

    public customerName: string = "",
    public date: string = "",
    public terms_id: string = null,
    public status: string = "Open",
    public conditions_id: string = null,
    public currency: string = "USD",
    public promise_date: string = "",
    public rep_id: string = null,

    public contactcontact: string = "",
    public contactcontactuser_id: number = null, // ligado a USERS
    public contactcompany: string = "",
    public contactemail: string = "",
    public contactfax: string = "",
    public contactphone: string = "",
    public contactaddress1: string = "",
    public contactaddress2: string = "",
    public contactcity: string = "",
    public contactstate: string = "",
    public contaccountry: string = "",
    public contactpostalcode: string = "",

    public setDefaultFromLocation: boolean = false,
    public shipfromlocation_id: string = null,
    public shipfromname: string = "",
    public shipfromcompany: string = "",
    public shipfromcontactuser_id: number = null, // ligado a USERS
    public shipfromcontact: string = "",
    public shipfromemail: string = "",
    public shipfromfax: string = "",
    public shipfromphone: string = "",
    public shipfromaddress1: string = "",
    public shipfromaddress2: string = "",
    public shipfromcity: string = "",
    public shipfromstate: string = "",
    public shipfromcountry: string = "",
    public shipfrompostalcode: string = "",

    public setDefaultToLocation: boolean = false,
    public shiptolocation_id: string = null,
    public shiptoname: string = "",
    public shiptocompany: string = "",
    public shiptoclientuser_id: number = null, // ligado a USERS
    public shiptocontact: string = "",
    public shiptophone: string = "",
    public shiptoemail: string = "",
    public shiptofax: string = "",
    public shiptoaddress1: string = "",
    public shiptoaddress2: string = "",
    public shiptocity: string = "",
    public shiptostate: string = "",
    public shiptocountry: string = "",
    public shiptopostalcode: string = "",

    public internalcomments: string = "",
    public commentstocustomer: string = "",

    public automaticReceive: boolean = false,
    public erasuremethod = null,
    public reference: string = "",
    public suppliermargin: number = 0,
    public vendorso: string = "",
    public extendedcost: number = 0.0,
    public freight: number = 0.0,
    public extracost: number = 0.0,
    public subtotal: number = 0.0,
    public tax: number = 0.0,
    public total: number = 0.0,
    public state_tax: number = null,
    public warehouse_id: number = null,
    public warehouse_name: string = '',
    public shipstatus: string = "",
    public receivestatus: string = '',
    public create_on_iq: number = 0
  ) {}
}